module.exports = __webpack_public_path__ + "static/media/18ECA15.a332db0f.jpg";